import React, { useEffect } from "react";
import TabPanel from "../../../../components/widgets/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

// Form provider
import { useForm, FormProvider } from "react-hook-form";
// import axios, { secondAxios } from "../../../../api/axios";
import { Alert, Snackbar, Typography, createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
// import TankData from "./Tank_Tab_Data/TankData";
// import TankCalculation from "./TankCalculation";
import { theme } from "../../../../styles/theme";
import { tabProps, tabScrollerProps } from "../../../../styles/muiProps";
import EstimationTab from "./Tank_Estimation";
// import MCSPage from "../CommonFeatures/MCSTab";
// import PCS from "../CommonFeatures/PCSTab";
import { useNavigate, useParams } from "react-router-dom";
import { CommonTabs } from "../CommonFeatures/tabs";
import { getProjectById } from "./api";
import { getHashdata } from "../PressureVessel/utils";
import { useAuthContext } from "../../../../context/authContext";

// const DrawerIcons = [
//   <HomeIcon />,
//   <CreateNewFolderIcon />,
//   <FileOpenIcon />,
//   <SaveIcon />,
// ];

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
//   justifyContent: "flex-end",
//   backgroundColor: "#eaecee",
// }));

const TankMain = () => {
  // const [openDrawer, setOpenDrawer] = React.useState(false); //file menu bar
  // const [open, setOpen] = React.useState(false);

  const { user } = useAuthContext();
  const [project, setProject] = React.useState({});
  const [key, setKey] = React.useState(Math.random());
  const { id: projectId, equipId } = useParams();

  const navigate = useNavigate();

  const isAdmin = user?.roles?.includes("Admin");
  const userRolesInProject = () => {
    if (!isAdmin) {
      return (
        project?.usersProjects?.find((u) => u.userId === user?.id)?.roles || []
      );
    }
  };

  // console.log("user From Main Page:", isAdmin);

  const x = {
    "Estimation Engineer": ["Est."],
    "Design Engineer": ["DCS", "PCS"],
    "Purchase Engineer": ["Est.", "MCS", "DCS"],
    "Project Engineer": ["Est.", "DCS", "MCS", "PCS"],
    "Project Manager": ["Est.", "DCS", "MCS", "PCS", "PMS"],
  };

  let viewedTabs = ["MCS"];
  const navLabel = "main-nav";

  isAdmin && (viewedTabs = ["Est.", "DCS", "MCS", "PCS", "PMS"]);

  const getCurrentTab = () => {
    if (!viewedTabs.length) return null;

    const hashValue = getHashdata(window.location.hash, navLabel);
    // console.log({ hashValue });

    const tabIndex = viewedTabs.findIndex((tab) => tab === hashValue);
    // console.log({ tabIndex });
    if (tabIndex !== -1) {
      return tabIndex;
    } else {
      window.location.hash = navLabel + "=" + viewedTabs[1];
      return 1;
    }
  };
  // const [currentTab, setCurrentTab] = React.useState(getCurrentTab() || 0); //index of the current tab
  const [currentTab, setCurrentTab] = React.useState(0); //index of the current tab

  // console.log("viewedTabs:", viewedTabs);
  userRolesInProject()?.forEach((r) => {
    // ...new Set([...viewedTabs, ...x[r]])
    viewedTabs = [...new Set([...viewedTabs, ...x[r]])];
  });

  //form handler
  const methods = useForm();

  //handles changes in tab
  const handleTabChange = (event, newValue) => {
    // console.log({ newValue });
    setCurrentTab(newValue);
    window.location.hash = navLabel + "=" + viewedTabs[newValue];
  };

  const reRender = () => {
    setKey(Math.random());
  };

  useEffect(() => {
    // console.log(projectId);

    const getProjectFile = async () => {
      // console.log("projectId", projectId);

      const res = await getProjectById({
        projectId: projectId,
      });

      methods.reset(res);
      setProject(res);
    };
    getProjectFile();
  }, []);

  useEffect(() => {
    if (viewedTabs.length > 0) {
      const currentTab = getCurrentTab();
      if (currentTab !== null) setCurrentTab(currentTab);
    }
  }, [viewedTabs]);

  // console.log("project-main :", project);
  return (
    <ThemeProvider theme={theme}>
      <FormProvider {...methods}>
        {" "}
        {/*  pass all methods into the context */}
        <Box sx={{ width: "100%" }}>
          <Box {...tabScrollerProps}>
            <Tabs
              sx={{ position: "relative" }}
              value={currentTab}
              onChange={handleTabChange}
              {...tabProps}
            >
              {viewedTabs.map((tabName) => {
                return (
                  <Tab
                    key={tabName}
                    label={tabName}
                    sx={{ fontWeight: "bold" }}
                  />
                );
              })}

              <Typography
                variant="h6"
                color="secondary"
                m={"auto 10px"}
                sx={{ position: "absolute", right: 30 }}
              >
                <Typography
                  variant="span"
                  m={"auto 10px"}
                  sx={{ color: "#444" }}
                >
                  Project :
                </Typography>
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={() => {
                    navigate("/plant/" + project?.plant?.id);
                  }}
                >
                  {project?.plant?.name}
                </span>{" "}
                / {project?.name}
              </Typography>
            </Tabs>

            {CommonTabs(reRender, project).map((tab, index) => {
              if (tab.title === "EstimationTab") {
                return (
                  <TabPanel
                    value={viewedTabs[currentTab]}
                    index={tab.id}
                    padding={tab.panelProps?.padding ?? 0}
                    key={index}
                  >
                    <EstimationTab />
                  </TabPanel>
                );
              }
              return (
                <TabPanel
                  value={viewedTabs[currentTab]}
                  index={tab.id}
                  padding={tab.panelProps?.padding ?? 0}
                  key={index}
                >
                  {tab.panel}
                </TabPanel>
              );
            })}
            {/* //////////// */}
          </Box>
        </Box>
      </FormProvider>
    </ThemeProvider>
  );
};

export default TankMain;
